import React from 'react';

const ShareIcon2 = (props: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.87609 9.35101H5.81378C4.67435 9.35101 3.75146 10.3192 3.75146 11.5145V19.0869C3.75146 20.2822 4.67435 21.2504 5.81378 21.2504H18.1877C19.3271 21.2504 20.25 20.2822 20.25 19.0869V11.5145C20.25 10.3192 19.3271 9.35101 18.1877 9.35101H16.1253"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12.0007 2.7381V13.3153" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M8.72674 5.87674L11.9895 2.7381L15.2532 5.87674"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ShareIcon2;
